import { apiClient, Auth } from '@/shared/api'

import { THostCalculatedRefundInformation } from '../model/schema'

export const getHostCalculatedRefundInfo = async (contractId: number) => {
  const response = await apiClient.get<THostCalculatedRefundInformation>({
    endpoint: `/host/contracts/${contractId}/calculated-refund-info`,
    auth: Auth.REQUIRED,
  })

  return response
}
